<template>
  <div>
    <ts-dialog title="Add a document" :visible.sync="visible" width="850px" center :show-close="false">
      <div v-show="selectedAssetTypeId === 'uploaded-file'" class="horizontal-form">
        <ts-form-item label="File" :validation="$v.form.uploadedFile" :offset="18" class="form-item">
          <ts-button ref="upload" :style="{ width: '100%' }"> Select file </ts-button>
        </ts-form-item>
        <ts-form-item label="File name" :validation="$v.form.uploadedFileName" class="form-item">
          <ts-input v-model="$v.form.uploadedFileName.$model"></ts-input>
        </ts-form-item>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleUploadClick">Upload</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" @click="handleOpenPickerButtonClick"> Add files </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.form-item {
  margin: 12px 0 12px 12px;
}

.horizontal-form {
  display: flex;

  > * {
    margin-right: 12px;
  }
}
</style>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {},
  props: {
    resumable: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      initialized: false,
      selectedAssetTypeId: 'uploaded-file',
      form: {
        googleDriveLinkFileName: '',
        googleDriveLinkUrl: '',
        uploadedFile: null,
        uploadedFileName: ''
      }
    };
  },
  validations: {
    form: {
      uploadedFile: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'uploaded-file';
        })
      },
      uploadedFileName: {
        required: requiredIf(function () {
          return this.selectedAssetTypeId === 'uploaded-file';
        })
      }
    }
  },
  methods: {
    resetForm() {
      for (const file of this.resumable.files) {
        this.resumable.removeFile(file);
      }

      this.form = {
        googleDriveLinkFileName: '',
        googleDriveLinkUrl: '',
        uploadedFile: null,
        uploadedFileName: ''
      };
      this.$v.$reset();
    },
    handleOpenPickerButtonClick() {
      this.visible = true;
      this.resetForm();
      if (!this.initialized) {
        this.$nextTick(() => {
          this.resumable.assignBrowse(this.$refs.upload.$el);
          this.resumable.on('fileAdded', file => {
            this.$v.form.uploadedFile.$model = file;
            this.$v.form.uploadedFileName.$model = file.fileName;
          });
          this.initialized = true;
        });
      }
    },
    handleUploadClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.selectedAssetTypeId === 'uploaded-file') {
          this.$emit('input', {
            name: this.form.uploadedFileName,
            resumableFile: this.form.uploadedFile,
            type: 'uploaded-file'
          });
        }
        this.visible = false;
      }
    }
  }
};
</script>
